import Cookies from 'js-cookie'
import { JUNE_ID_COOKIE_KEY } from '@/lib/sharedConstants'

export function handleNewsletterApiErrors<T>(promise: Promise<T>) {
  return promise.catch(() => (window.location.href = '/newsletter/error/'))
}

export function getJuneIdPartsWithCookieFallback() {
  const [collect_token, collect_id] = splitJuneId(
    new URLSearchParams(window.location.search).get('j_id') ||
      Cookies.get(JUNE_ID_COOKIE_KEY) ||
      '',
  )

  return { collect_id, collect_token }
}

function splitJuneId(juneId: string) {
  return juneId.split('-')
}

export function getJuneIdFromSearchParameters() {
  return new URLSearchParams(window.location.search).get('j_id')
}

export function getJuneIdWithErrorPage() {
  const juneId = getJuneIdFromSearchParameters()

  if (!juneId) {
    window.location.href = '/newsletter/error/'
  }

  return juneId!
}
